// src/components/MediaDisplay.js
import React, { useEffect, useRef, useState } from "react";

function MediaDisplay({
  content,
  contentType,
  savedTime,
  setSavedTime,
  wasPlaying,
  setWasPlaying,
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      setSavedTime(video.currentTime);
      setWasPlaying(!video.paused);
    };

    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [setSavedTime, setWasPlaying]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = savedTime;
      if (wasPlaying) {
        video.play().catch((e) => {
          // ignore autoplay errors (browser policies)
          console.warn("Auto-play blocked:", e);
        });
      }
    }
  }, [content]);

  if (contentType === "image") {
    return (
      <img
        src={content}
        alt="Media"
        className="w-full h-full m-auto object-contain"
        draggable="false"
      />
    );
  } else if (contentType === "video") {
    const getMimeType = (url) => {
      if (url.endsWith(".mp4")) return "video/mp4";
      if (url.endsWith(".webm")) return "video/webm";
      if (url.endsWith(".ogg")) return "video/ogg";
      return "video/mp4"; // fallback
    };

    return (
      <video
        ref={videoRef}
        controls
        className="w-full h-content max-h-content aspect-video object-contain rounded"
      >
        <source src={content} type={getMimeType(content)} />
        Your browser does not support the video tag.
      </video>
    );
  } else {
    return (
      <div className="shadow-md flex items-center justify-center w-full h-full">
        <p className="text-gray-500">Unsupported media type</p>
      </div>
    );
  }
}

export default MediaDisplay;
